export default {
  id: null,
  companyID: null,
  type: null,
  name: null,
  date: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/holidaymodel.js